var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon6",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "premium-icon-screwdriver-698728",
    transform: "translate(489.641 887.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33745",
    "data-name": "\\uD328\\uC2A4 33745",
    d: "M270.838,3.931c-.077.187.466-.432-9.582,9.7l1.425,1.425c10.06-10.1,9.446-9.564,9.646-9.646,2.577-1.108,2.727-1,2.866-1.334l1.038-2.536a.263.263,0,0,0-.057-.286L274.99.072a.248.248,0,0,0-.27-.054L272.2,1.051a.553.553,0,0,0-.3.3Z",
    transform: "translate(-245.583 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33746",
    "data-name": "\\uD328\\uC2A4 33746",
    d: "M271.564,4.627l1.071-2.617a.561.561,0,0,1,.307-.307C275.666.591,275.5.649,275.558.639l-.567-.567a.248.248,0,0,0-.27-.054L272.2,1.051a.553.553,0,0,0-.3.3l-1.055,2.578c-.077.187.47-.436-9.582,9.7l.711.711C271.941,4.286,271.485,4.819,271.564,4.627Z",
    transform: "translate(-245.584 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33747",
    "data-name": "\\uD328\\uC2A4 33747",
    d: "M12.815,463.995l-.428.428a1.007,1.007,0,0,0,0,1.425h0a1.008,1.008,0,0,0,1.425,0l.428-.428Z",
    transform: "translate(-11.323 -436.248)",
    fill: "#606c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33748",
    "data-name": "\\uD328\\uC2A4 33748",
    d: "M12.9,466.122c-.165-.791.519-1.17.667-1.373l-.755-.755-.428.428a1.007,1.007,0,0,0,0,1.425h0A1,1,0,0,0,12.9,466.122Z",
    transform: "translate(-11.323 -436.247)",
    fill: "#4e5b68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33749",
    "data-name": "\\uD328\\uC2A4 33749",
    d: "M445.13,1.543a.263.263,0,0,0-.057-.286L443.888.073a.248.248,0,0,0-.27-.054c-2.639,1.1-2.569,1.008-2.719,1.168l3.069,3.069C444.115,4.12,444.022,4.2,445.13,1.543Z",
    transform: "translate(-414.482 -0.001)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33750",
    "data-name": "\\uD328\\uC2A4 33750",
    d: "M444.457.64l-.567-.567a.248.248,0,0,0-.27-.054c-2.661,1.089-2.586,1.033-2.719,1.168l.7.7c.171-.23.219-.148,2.8-1.234A.246.246,0,0,1,444.457.64Z",
    transform: "translate(-414.483 -0.001)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33751",
    "data-name": "\\uD328\\uC2A4 33751",
    d: "M234.465,219.967h0a1.016,1.016,0,0,1-1.433,0l-1.85-1.85a1.016,1.016,0,0,1,0-1.433h0a1.016,1.016,0,0,1,1.433,0l1.85,1.85A1.016,1.016,0,0,1,234.465,219.967Z",
    transform: "translate(-217.03 -203.449)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33752",
    "data-name": "\\uD328\\uC2A4 33752",
    d: "M233.856,217.923l-1.241-1.241a1.013,1.013,0,0,0-1.433,1.433l1.316,1.316A1.136,1.136,0,0,1,233.856,217.923Z",
    transform: "translate(-217.03 -203.448)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33753",
    "data-name": "\\uD328\\uC2A4 33753",
    d: "M9.687,258.791a1.635,1.635,0,0,1-1.35.994,3.632,3.632,0,0,0-1.941.842c-.273.232-.258.253-5.281,5.263a3.665,3.665,0,0,0,0,5.167l1.813,1.813a3.665,3.665,0,0,0,5.167,0l5.065-5.065a3.641,3.641,0,0,0,1.044-2.183,1.633,1.633,0,0,1,.99-1.324Z",
    transform: "translate(0 -243.318)",
    fill: "#f7ab31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33754",
    "data-name": "\\uD328\\uC2A4 33754",
    d: "M2.774,267.706c5.509-5.507,5.286-5.306,5.569-5.523a3.742,3.742,0,0,1,1.867-.745,1.668,1.668,0,0,0,1.275-.848l-1.8-1.8a1.636,1.636,0,0,1-1.35.994,3.641,3.641,0,0,0-1.679.639c-.41.289-.233.17-5.542,5.466a3.665,3.665,0,0,0,0,5.167l.942.942A3.763,3.763,0,0,1,2.774,267.706Z",
    transform: "translate(0 -243.319)",
    fill: "#e59520"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33755",
    "data-name": "\\uD328\\uC2A4 33755",
    d: "M180.39,224.973a2.026,2.026,0,0,0-1.017.658l5.738,5.738.2-.2a1.752,1.752,0,0,0,0-2.47h0l-3.267-3.267h0A1.75,1.75,0,0,0,180.39,224.973Z",
    transform: "translate(-168.598 -211.473)",
    fill: "#606c7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56426",
    "data-name": "\\uADF8\\uB8F9 56426",
    transform: "translate(2.09 18.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33756",
    "data-name": "\\uD328\\uC2A4 33756",
    d: "M34.623,314.928a.463.463,0,0,1-.327-.789l5.73-5.73a.462.462,0,1,1,.653.654l-5.73,5.73A.461.461,0,0,1,34.623,314.928Z",
    transform: "translate(-34.16 -308.274)",
    fill: "#d18118"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33757",
    "data-name": "\\uD328\\uC2A4 33757",
    d: "M63.482,343.968a.462.462,0,0,1,0-.654l5.73-5.73a.462.462,0,1,1,.653.654l-5.73,5.73A.462.462,0,0,1,63.482,343.968Z",
    transform: "translate(-61.601 -335.704)",
    fill: "#d18118"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33758",
    "data-name": "\\uD328\\uC2A4 33758",
    d: "M92.659,373.146a.462.462,0,0,1,0-.654l5.73-5.73a.462.462,0,1,1,.653.653l-5.73,5.73A.462.462,0,0,1,92.659,373.146Z",
    transform: "translate(-89.032 -363.136)",
    fill: "#d18118"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56427",
    "data-name": "\\uADF8\\uB8F9 56427",
    transform: "translate(9.523 13.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33759",
    "data-name": "\\uD328\\uC2A4 33759",
    d: "M159.691,236.748c-.7.7-.9.842-1.068,1.271a1.694,1.694,0,0,1-.184.343l5.376,5.376c.34-.235.564-.2.933-.571l.681-.681Z",
    transform: "translate(-158.439 -236.041)",
    fill: "#4e5b68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33760",
    "data-name": "\\uD328\\uC2A4 33760",
    d: "M183.084,226.474l-1.043-1.043h0a1.75,1.75,0,0,0-1.652-.46,2.025,2.025,0,0,0-1.017.658l1.758,1.758A2.3,2.3,0,0,1,183.084,226.474Z",
    transform: "translate(-178.121 -224.922)",
    fill: "#4e5b68"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33761",
    "data-name": "\\uD328\\uC2A4 33761",
    d: "M160.831,239.126l.619-.619-1.758-1.758c-.654.657-.9.836-1.068,1.271a1.694,1.694,0,0,1-.184.343l1.774,1.774C160.459,239.77,160.429,239.528,160.831,239.126Z",
    transform: "translate(-148.917 -222.592)",
    fill: "#43505b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon6);
export default __webpack_public_path__ + "static/media/sec2Icon6.ce25be3bac96c10efb9c437b5ab96c81.svg";
export { ForwardRef as ReactComponent };